import * as yup from 'yup'

export const asalMuatValidation = yup.object().shape({
    companyId: yup.string().required('Harus diisi'),
    namaPerusahaan: yup.string().required('Harus diisi'),
    alamat: yup.string().required('Harus diisi'),   
    locationType: yup.string().required('Harus diisi'),   
    latitude: yup.number().required('Harus diisi'),   
    longitude: yup.number().required('Harus diisi'),   
    provinceId: yup.string().required('Harus diisi'),   
    regencyId: yup.string().required('Harus diisi'),   
    districtId: yup.string().required('Harus diisi'),   
    villageId: yup.string().required('Harus diisi'),  
}).required()

export const inlineAsalMuatValidation = yup.object().shape({
    namaPerusahaan: yup.string().required('Harus diisi'),
    alamat: yup.string().required('Harus diisi'),   
    locationType: yup.string().required('Harus diisi'),   
    latitude: yup.number().required('Harus diisi'),   
    longitude: yup.number().required('Harus diisi'),   
    provinceId: yup.string().required('Harus diisi'),   
    regencyId: yup.string().required('Harus diisi'),   
    districtId: yup.string().required('Harus diisi'),   
    villageId: yup.string().required('Harus diisi'),  
}).required()